import script from "./AgentInput.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentInput.vue?vue&type=script&setup=true&lang=js"

import "./AgentInput.vue?vue&type=style&index=0&id=b4faa85e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4faa85e"]])

export default __exports__